import axios from "axios";
import qs from "qs";

const DEFAULT_BASE = "https://backsanpancracio.us-3.evennode.com/";
let BASE_URL = process.env.REACT_APP_API_BASE || DEFAULT_BASE;

if (
  typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  BASE_URL.startsWith("http://")
) {
  console.warn("[rutaUsuarios] Corrigiendo BASE_URL insegura:", BASE_URL);
  BASE_URL = BASE_URL.replace("http://", "https://");
}

const api = axios.create({
  baseURL: BASE_URL,
  withCredentials: false,
});

// 🔐 Login
export const postLogin = async (datos) => {
  try {
    const resp = await api.post("/login", qs.stringify(datos), {
      headers: { "content-type": "application/x-www-form-urlencoded" },
    });
    return { data: resp.data, loading: false };
  } catch (error) {
    return {
      data: error.response?.data || { error: "Error desconocido" },
      loading: false,
    };
  }
};

// 📄 Traer todos los usuarios
export const getUsuarios = async () => {
  try {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("jwt") ||
      "";

    const resp = await api.get("/usuarios", {
      headers: {
        token,
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });

    return resp.data;
  } catch (error) {
    return {
      data: error.response?.data || { error: "Error desconocido" },
      loading: false,
    };
  }
};

// 📌 Traer un usuario por ID
export const getUsuarioId = async (id) => {
  try {
    const resp = await api.get(`/usuarios/${id}`);
    return resp.data;
  } catch (error) {
    return {
      data: error.response?.data || { error: "Error desconocido" },
      loading: false,
    };
  }
};